(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7674],{

/***/ 3463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Services_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3721);
/* harmony import */ var _Services_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_Services_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var src_helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(682);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4012);
/* harmony import */ var _public_logo_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3476);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2873);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8116);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
      d: "M4.6 6.5c0-.35.135-.7.4-.965l3.26-3.26a.377.377 0 0 1 .53 0 .377.377 0 0 1 0 .53l-3.26 3.26c-.24.24-.24.63 0 .87l3.26 3.26a.377.377 0 0 1 0 .53.377.377 0 0 1-.53 0L5 7.465a1.363 1.363 0 0 1-.4-.965Z",
      fill: "#000"
    })
  }));
};

ArrowLeft.defaultProps = {
  width: "30",
  height: "30",
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
      d: "M9.4 6.5c0 .35-.135.7-.4.965l-3.26 3.26a.377.377 0 0 1-.53 0 .377.377 0 0 1 0-.53l3.26-3.26c.24-.24.24-.63 0-.87l-3.26-3.26a.377.377 0 0 1 0-.53.377.377 0 0 1 .53 0L9 5.535c.265.265.4.615.4.965Z",
      fill: "#000"
    })
  }));
};

ArrowRight.defaultProps = {
  width: "30",
  height: "30",
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};









var ServiceSlide = function ServiceSlide(_ref) {
  var _titleStyle, _service$title, _service$title2, _service$title3;

  var service = _ref.service,
      dir = _ref.dir,
      locale = _ref.locale;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  var blockStyle = {
    textAlign: "center",
    boxShadow: "0 0 10px #0000001a",
    borderRadius: "10px",
    height: "calc(100% - 25px)",
    transition: "0.3s",
    transform: isHovered ? "translateY(-10px)" : "translateY(0)",
    textDecoration: "none"
  };
  var blockImgStyle = {
    borderRadius: "10px 10px 0 0",
    position: "relative",
    overflow: "hidden",
    height: "200px",
    margin: "0 auto",
    backgroundColor: "#f7f7f7",
    border: "1px solid #dfdfdf"
  };
  var imgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "0.3s",
    transform: isHovered ? "scale(1.1)" : "scale(1)"
  };
  var linkStyle = {
    position: "absolute",
    inset: "0",
    zIndex: "1"
  };
  var contentStyle = {
    padding: "20px"
  };
  var titleStyle = (_titleStyle = {
    fontSize: "18px",
    display: "inline-block",
    fontWeight: "700",
    color: isHovered ? "#e72229" : "black"
  }, (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_titleStyle, "display", "-webkit-box"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_titleStyle, "WebkitLineClamp", "2"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_titleStyle, "lineClamp", "2"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_titleStyle, "WebkitBoxOrient", "vertical"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_titleStyle, "overflow", "hidden"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_titleStyle, "transition", "0.3s"), _titleStyle);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    style: blockStyle,
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      style: blockImgStyle,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_11___default()), {
        href: "/services/".concat(service === null || service === void 0 ? void 0 : service.slug),
        legacyBehavior: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          style: linkStyle
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_3___default()), {
        src: (0,src_helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_2__/* .buildApiUrl */ .f8)(service === null || service === void 0 ? void 0 : service.image),
        alt: "service-img",
        width: 1920,
        height: 1080,
        loading: "lazy",
        quality: 100,
        style: imgStyle
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      style: contentStyle,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_11___default()), {
        href: "/services/".concat(service === null || service === void 0 ? void 0 : service.slug),
        legacyBehavior: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          style: titleStyle,
          children: (service === null || service === void 0 ? void 0 : (_service$title = service.title) === null || _service$title === void 0 ? void 0 : _service$title[locale].length) > 50 ? (service === null || service === void 0 ? void 0 : (_service$title2 = service.title) === null || _service$title2 === void 0 ? void 0 : _service$title2[locale].slice(0, 50)) + "..." : service === null || service === void 0 ? void 0 : (_service$title3 = service.title) === null || _service$title3 === void 0 ? void 0 : _service$title3[locale].slice(0, 50)
        })
      })
    })]
  });
};

var Services = function Services(_ref2) {
  var AllServicesData = _ref2.AllServicesData;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)(),
      locale = _useRouter.locale;

  var dir = locale === "ar" ? "rtl" : "ltr";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
    className: (_Services_module_scss__WEBPACK_IMPORTED_MODULE_12___default().services),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__["default"], {
      children: [(AllServicesData === null || AllServicesData === void 0 ? void 0 : AllServicesData.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "custom-head",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            id: "services"
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .t, {
        dir: dir,
        modules: [swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_],
        navigation: true,
        spaceBetween: 0,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 150
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 50
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 50
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 50
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 50
          }
        },
        children: (AllServicesData === null || AllServicesData === void 0 ? void 0 : AllServicesData.length) > 0 && (AllServicesData === null || AllServicesData === void 0 ? void 0 : AllServicesData.map(function (service, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ServiceSlide, {
              service: service,
              dir: dir,
              locale: locale
            })
          }, index);
        }))
      }, dir)]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Services);

/***/ }),

/***/ 3721:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__9_oWS"};

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);